import { useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import SlideLeft from "../SlideLeft/SlideLeft";
import { IErrorAlert } from "src/types/atoms";
const ErrorAlert = ({
  open,
  onClose,
  message,
  duration = 5000
}: IErrorAlert) => {
  useEffect(() => {
    let timer = setTimeout(onClose, duration);
    return () => {
      clearTimeout(timer);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return <Snackbar open={open} TransitionComponent={SlideLeft} anchorOrigin={{
    vertical: "top",
    horizontal: "right"
  }} sx={{
    position: "absolute",
    zIndex: 10000
  }}>
      <Alert onClose={onClose} severity="error" sx={{
      position: "relative",
      bottom: 10
    }}>
        {message}
      </Alert>
    </Snackbar>;
};
export default ErrorAlert;